// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3WXYQ","title":"InfoRow_title__1gHvj"};